import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import API from "../api";

const StockManagement = () => {
    const [products, setProducts] = useState([]);
    const [activeTab, setActiveTab] = useState("all");

    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    // PAGINATION STATE
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(5);

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const res = await API.get("/products");
            setProducts(res.data || []);
        } catch (err) {
            console.log(err);
        }
    };

    // Format Date & Time
    const formatDate = (date) =>
        new Date(date).toLocaleDateString();

    const formatTime = (date) =>
        new Date(date).toLocaleTimeString();


    // CALCULATIONS (FIXED)
    const totalProducts = products.length;

    // const lowStockCount = products.filter(
    //     (p) =>
    //         p.quantityStock < 10 &&
    //         p.quantityStock > 0
    // ).length;
    const LOW_PCS = 10;
    const LOW_KG = 100;

    const lowStockCount = products.filter(
        (p) =>
            (p.quantityStock < LOW_PCS && p.quantityStock > 0) ||
            (p.kgStock < LOW_KG && p.kgStock > 0)
    ).length;

    const outOfStockCount = products.filter(
        (p) =>
            p.quantityStock <= 0 &&
            p.kgStock <= 0
    ).length;

    const stockValue = products.reduce((total, p) => {

        const qtyValue =
            Number(p.quantityStock || 0) *
            Number(p.quantityCostPrice || 0);

        const kgValue =
            Number(p.kgStock || 0) *
            Number(p.kgCostPrice || 0);

        return total + qtyValue + kgValue;

    }, 0);

    // FILTER
    const filteredProducts = products.filter((p) => {

        // if (activeTab === "low") {

        //     return (
        //         p.quantityStock < 10 &&
        //         p.quantityStock > 0
        //     );
        // }
        if (activeTab === "low") {
            return (
                (p.quantityStock < LOW_PCS && p.quantityStock > 0) ||
                (p.kgStock < LOW_KG && p.kgStock > 0)
            );
        }

        if (activeTab === "out") {

            return (
                p.quantityStock <= 0 &&
                p.kgStock <= 0
            );
        }

        return true;
    });

    // ================= PAGINATION LOGIC =================
    const totalPages = Math.ceil(filteredProducts.length / limit);

    const startIndex = (page - 1) * limit;
    const paginatedProducts = filteredProducts.slice(
        startIndex,
        startIndex + limit
    );

    // RESET PAGE WHEN TAB CHANGES
    useEffect(() => {
        setPage(1);
    }, [activeTab, limit]);

    return (
        <Layout>
            {/* NAVIGATION */}
            <div className="tab-navigation">
                <button
                    className={activeTab === "all" ? "active" : ""}
                    onClick={() => setActiveTab("all")}
                >
                    📦 All Products
                </button>

                <button
                    className={activeTab === "low" ? "active" : ""}
                    onClick={() => setActiveTab("low")}
                >
                    ⚠️ Low Stock
                </button>

                <button
                    className={activeTab === "out" ? "active" : ""}
                    onClick={() => setActiveTab("out")}
                >
                    ❌ Out Of Stock
                </button>

                <button
                    className={activeTab === "movement" ? "active" : ""}
                    onClick={() => setActiveTab("movement")}
                >
                    🔄 Stock Movements
                </button>

            </div>

            {/* ================= MOVEMENT PAGE ================= */}
            {activeTab === "movement" ? (
                <div className="movement-section">

                    {/* TOP CARDS */}
                    <div className="movement-cards">
                        <div className="m-card blue">
                            <h3>{products.length}</h3>
                            <p>Total Movements</p>
                        </div>

                        <div className="m-card green">
                            <h3>
                                {
                                    products.reduce((t, p) => {

                                        return t +
                                            Number(p.quantityStock || 0) +
                                            Number(p.kgStock || 0);

                                    }, 0)
                                }
                            </h3>
                            <p>Stock In</p>
                        </div>

                        <div className="m-card red">
                            <h3>
                                {
                                    products.filter(
                                        p =>
                                            p.quantityStock <= 0 &&
                                            p.kgStock <= 0
                                    ).length
                                }
                            </h3>
                            <p>Stock Out</p>
                        </div>
                    </div>

                    {/* MOVEMENT LIST */}
                    <div className="movement-list">

                        {
                            products.map((p) => {

                                const totalStock =
                                    Number(p.quantityStock || 0) +
                                    Number(p.kgStock || 0);

                                return (

                                    <div
                                        key={p._id}
                                        className="movement-item"
                                    >

                                        {/* LEFT */}

                                        <div className="left">

                                            <button
                                                className={`circle-btn ${totalStock > 0
                                                    ? "green"
                                                    : "red"
                                                    }`}
                                                onClick={() => {

                                                    setSelectedProduct(p);

                                                    setShowModal(true);

                                                }}
                                            >
                                                {
                                                    totalStock > 0
                                                        ? "+"
                                                        : "-"
                                                }
                                            </button>

                                            <div>
                                                <h4>{p.name}</h4>

                                                <p>
                                                    Ref:
                                                    {" "}
                                                    {p._id.slice(0, 8)}...
                                                </p>
                                            </div>

                                        </div>

                                        {/* RIGHT */}

                                        <div className="right">

                                            <span
                                                className={
                                                    totalStock > 0
                                                        ? "text-green"
                                                        : "text-red"
                                                }
                                            >
                                                {
                                                    p.quantityStock > 0
                                                        ? `+${p.quantityStock} PCS`
                                                        : p.kgStock > 0
                                                            ? `+${p.kgStock} KG`
                                                            : "0"
                                                }
                                            </span>

                                        </div>

                                    </div>
                                );
                            })
                        }

                    </div>

                    {/* MODAL */}
                    {showModal && selectedProduct && (
                        <div className="modal-overlay" onClick={() => setShowModal(false)}>
                            <div className="modal-box" onClick={(e) => e.stopPropagation()}>

                                <div className="modal-header">
                                    <h3>Stock Movement Details</h3>
                                </div>

                                <div className="modal-content">
                                    <div className="detail-row">
                                        <span>Product:</span>
                                        <strong>{selectedProduct.name}</strong>
                                    </div>

                                    <div className="detail-row">
                                        <span>Category:</span>
                                        <strong>
                                            {selectedProduct.category}
                                        </strong>
                                    </div>

                                    <div className="detail-row">
                                        <span>Quantity Stock:</span>

                                        <strong>
                                            {
                                                selectedProduct.quantityStock
                                            } PCS
                                        </strong>
                                    </div>

                                    <div className="detail-row">
                                        <span>Quantity Sell Price:</span>

                                        <strong>
                                            ₹{
                                                selectedProduct.quantitySellingPrice
                                            }
                                        </strong>
                                    </div>

                                    <div className="detail-row">
                                        <span>KG Stock:</span>

                                        <strong>
                                            {
                                                selectedProduct.kgStock
                                            } KG
                                        </strong>
                                    </div>

                                    <div className="detail-row">
                                        <span>KG Sell Price:</span>

                                        <strong>
                                            ₹{
                                                selectedProduct.kgSellingPrice
                                            }
                                        </strong>
                                    </div>

                                    <div className="detail-row">
                                        <span>Status:</span>

                                        <strong>
                                            {
                                                selectedProduct.quantityStock <= 0 &&
                                                    selectedProduct.kgStock <= 0
                                                    ? "Stock Out"
                                                    : "Stock In"
                                            }
                                        </strong>
                                    </div>
                                </div>

                                <div className="detail-row">
                                    <span>Reason:</span>

                                    <strong>
                                        {
                                            selectedProduct.quantityStock > 0 ||
                                                selectedProduct.kgStock > 0
                                                ? "Purchase"
                                                : "Sale"
                                        }
                                    </strong>
                                </div>

                                <div className="detail-row">
                                    <span>Date:</span>
                                    <strong>
                                        {selectedProduct.createdAt
                                            ? formatDate(selectedProduct.createdAt)
                                            : "N/A"}
                                    </strong>
                                </div>

                                <div className="detail-row">
                                    <span>Time:</span>
                                    <strong>
                                        {selectedProduct.createdAt
                                            ? formatTime(selectedProduct.createdAt)
                                            : "N/A"}
                                    </strong>
                                </div>

                                <button
                                    onClick={() => setShowModal(false)}
                                    className="modal-close-btn"
                                >
                                    Close
                                </button>

                            </div>
                        </div>
                    )}

                    {/* FLOAT BUTTON */}
                </div>
            ) : (
                <>
                    {/* CARDS */}
                    <div className="stock-cards">
                        <div className="stock-card blue">
                            <h3>{totalProducts}</h3>
                            <p>Total Products</p>
                        </div>

                        <div className="stock-card yellow">
                            <h3>{lowStockCount}</h3>
                            <p>Low Stock</p>
                        </div>

                        <div className="stock-card red">
                            <h3>{outOfStockCount}</h3>
                            <p>Out of Stock</p>
                        </div>

                        <div className="stock-card green">
                            <h3>₹{stockValue.toLocaleString()}</h3>
                            <p>Stock Value</p>
                        </div>
                    </div>



                    {/* LIST */}
                    {/* LEFT */}
                    <div className="left-controls">
                        <span>Show</span>
                        <select
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1);
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                        </select>
                        <span>entries</span>
                    </div>

                    <div className="table-responsive">
                        <table className="stock-table">
                            <thead>
                                <tr>
                                    <th>S/N</th>
                                    <th>Product</th>
                                    <th>Category</th>
                                    <th>Stock</th>
                                    <th>Cost Price</th>
                                    <th>Selling Price</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {paginatedProducts.map((p, index) => (
                                    <tr key={p._id}>
                                        <td>
                                            {startIndex + index + 1}
                                        </td>
                                        <td>{p.name}</td>
                                        <td>{p.category || "-"}</td>

                                        <td>

                                            {
                                                p.quantityStock > 0
                                                    ? `${p.quantityStock} PCS`
                                                    : p.kgStock > 0
                                                        ? `${p.kgStock} KG`
                                                        : "--"
                                            }

                                        </td>

                                        <td>

                                            ₹
                                            {
                                                p.quantityCostPrice > 0
                                                    ? p.quantityCostPrice
                                                    : p.kgCostPrice
                                            }

                                        </td>

                                        <td>

                                            ₹
                                            {
                                                p.quantitySellingPrice > 0
                                                    ? p.quantitySellingPrice
                                                    : p.kgSellingPrice
                                            }

                                        </td>

                                        <td>

                                            <span
                                                className={

                                                    p.quantityStock <= 0 && p.kgStock <= 0
                                                        ? "status-out"
                                                        : (p.quantityStock < LOW_PCS && p.quantityStock > 0) ||
                                                            (p.kgStock < LOW_KG && p.kgStock > 0)
                                                            ? "status-low"
                                                            : "status-ok"
                                                }
                                            >

                                                {
                                                    p.quantityStock <= 0 && p.kgStock <= 0
                                                        ? "Out of Stock"
                                                        : (p.quantityStock < LOW_PCS && p.quantityStock > 0) ||
                                                            (p.kgStock < LOW_KG && p.kgStock > 0)
                                                            ? "Low Stock"
                                                            : "In Stock"
                                                }



                                            </span>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION */}
                    <div className="pagination">
                        <button
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                        >
                            Prev
                        </button>

                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                className={page === i + 1 ? "active" : ""}
                                onClick={() => setPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            disabled={page === totalPages}
                            onClick={() => setPage(page + 1)}
                        >
                            Next
                        </button>
                    </div>

                </>
            )}


        </Layout>
    );
};

export default StockManagement;
